import type { Delivery } from "@types_def/models/delivery.types";
import type { FunctionComponent } from "react";

export const PriceCell: FunctionComponent = ({ children }) => {
  const price = (children as Delivery)?.accepted_offer?.demandedPrice;

  if (!price) {
    return <i>Error</i>;
  }

  return <div>{price} €</div>;
};
